module.exports = __webpack_public_path__ + "img/cameroon.5629751.webp";